import { Suspense } from 'react'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router'
import ErrorBoundary from '@components/ErrorBoundary/ErrorBoundary'
import ErrorMessage from '@components/ErrorBoundary/ErrorMessage'
import { usePageConfig } from '@hooks/usePageConfig'
import TableDataSet from './TableDataSet/TableDataSet'
import ExternalHeaderContent from '@components/ExternalHeaderContent/ExternalHeaderContent'
import TableDataSetSkeleton from '@components/skeletons/TableDataSetSkeleton/TableDataSetSkeleton'
import { useDataset } from '@hooks/useCatalog'

import './DataSet.css'

const DataSetBreadcrumb = ({ id }: { id: string }) => {
  const intl = useIntl()
  const { dataset } = useDataset(id)
  const crumbs = [
    { label: intl.formatMessage({ id: 'nav.data-sets' }), path: '/data-sets' },
    { label: dataset?.title ?? id, path: `/data-sets/${id}` }
  ]
  return <ExternalHeaderContent hasBack crumbs={crumbs} />
}

export default function DataSet() {
  const { id } = useParams<{ id: string }>()
  usePageConfig('data-sets', <DataSetBreadcrumb id={id} />)

  return (
    <section id="data-set-content" className="main-content">
      <ErrorBoundary errorComponent={ErrorMessage}>
        <Suspense fallback={<TableDataSetSkeleton />}>
          <TableDataSet />
        </Suspense>
      </ErrorBoundary>
    </section>
  )
}
